module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-input"
  }, [_c('my-input', {
    attrs: {
      "tipText": _vm.schoolTip,
      "text": _vm.school,
      "isError": _vm.isError,
      "maxLength": _vm.maxLength
    },
    on: {
      "tipClick": _vm.schoolClick,
      "blurEvent": _vm.checkSchool
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65bdbe1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/education/eduAdd/gradSchool.vue
// module id = 358
// module chunks = 0